const LEGACY_ENV_KEY = 'REACT_APP_COTA_LEGACY_USERS';

const parseLegacyAccounts = () => {
  const raw = process.env[LEGACY_ENV_KEY];
  if (!raw) {
    return new Map();
  }

  return raw
    .split(';')
    .map((entry) => entry.trim())
    .filter(Boolean)
    .reduce((acc, entry) => {
      const separatorIndex = entry.indexOf(':');
      if (separatorIndex === -1) {
        return acc;
      }

      const username = entry.slice(0, separatorIndex).trim();
      const password = entry.slice(separatorIndex + 1).trim();

      if (!username || !password) {
        return acc;
      }

      acc.set(username.toLowerCase(), {
        username,
        password,
      });
      return acc;
    }, new Map());
};

const legacyAccountMap = parseLegacyAccounts();

export const matchLegacyCotaAccount = (username, password) => {
  const normalizedUsername = (username ?? '').trim();
  const normalizedPassword = (password ?? '').trim();

  if (!normalizedUsername || !normalizedPassword) {
    return null;
  }

  const record = legacyAccountMap.get(normalizedUsername.toLowerCase());
  if (!record) {
    return null;
  }

  if (record.password !== normalizedPassword) {
    return null;
  }

  return {
    username: record.username,
  };
};
